/**
 * Componente Header
 * Exibe informações do usuário e logo no cabeçalho
 */

import React from 'react';
import './Header.css';
import logo from '../../img/logo-prefeitura/logomarca-oficial.png';

function Header({ userName, userType, poloName, setIsLoggedIn, hideHeader }) {
  const isMobile = window.innerWidth <= 768;
  const showPolo = userType !== 'nutricionista' && poloName;

  if (hideHeader) return null;


  return (
    <div className="header-user-container print-hide" style={!isMobile ? { justifyContent: 'center', alignItems: 'center', padding: '12px 0 12px 0', left: 0, right: 0, position: 'fixed', top: 0, width: '100vw',  zIndex: 1003 } : {}}>

      {!isMobile && (
        <>
          <div className="user-info" style={{ alignItems: 'center', marginRight: 0, minWidth: 'unset', textAlign: 'center' }}>
            <div className="top-line" style={{ justifyContent: 'center' }}>
              <span className="user-name">{userName}</span>
              <span className="user-separator">-</span>
              <span className="user-type">{userType}</span>
            </div>
            {showPolo && <span className="polo-name">{poloName}</span>}
          </div>
          <img src={logo} alt="Logo" className="logo" style={{ position: 'static', marginLeft: 16, width: 90, height: 'auto' }} />
        </>
      )}
    </div>
  );
}

export default Header;